import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZingatComponent } from './simple-icons-zingat.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZingatComponent ],
    exports:      [ SimpleIconsZingatComponent ],
    bootstrap:    []
})
export class SimpleIconsZingatModule {}
